import { TFunction } from '@lyearn/i18n';
import { ExerciseQuestionInput } from '@/types/schema';

const validateImageHotspot = (t: TFunction, question?: ExerciseQuestionInput) => {
  if (question?.medias?.length === 0) {
    return {
      message: t('Exercise:Creator.ImageHotspotNoImage'),
    };
  }

  if (
    !question?.imageHotspots?.[0]?.hotspots.length ||
    question?.imageHotspots?.[0]?.hotspots.length < 2
  ) {
    return {
      message: t('Exercise:Creator.AtleastTwoHotspotsRequired'),
    };
  }
};

export default validateImageHotspot;
